<form [formGroup]="form">

  <section fxLayout="row" fxLayoutGap="8px">
    <div fxFlex="25">

      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Access per PON</mat-label>
        <input #verticalAccessPerPon type="number" matInput formControlName="horizontal_collective_access_per_pon">
      </mat-form-field>
      <app-suggestion [input]="verticalAccessPerPon" [options]="[32, 64, 128]"
        (changeSelection)="form.patchValue({horizontal_collective_access_per_pon: $event})">
      </app-suggestion>

    </div>
    <div fxFlex="75">

      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Unities minimum quantity to vertical</mat-label>
        <input type="number" #minimum matInput (change)="setMinimum($event.target.value)"
          [value]="range.length > 0 ? range[0] : ''" formControlName="minimum">
      </mat-form-field>
      <app-suggestion [input]="minimum" [options]="[5, 6, 7, 8, 9, 10, 11, 12]"
        (changeSelection)="minimum.value = $event; setMinimum($event)">
      </app-suggestion>

    </div>
  </section>

  <ng-container *ngIf="range.length">
    <section>
      <h3 i18n>Unit number by type</h3>
      <div>
        <div fxFlex="50">
          <app-type-range [values]="range" (valuesChange)="createTypes($event)" label="Type" i18n-label>
          </app-type-range>
        </div>
      </div>
    </section>

    <section>
      <mat-accordion>
        <mat-expansion-panel *ngFor="let type of parameters.horizontal_collective_settings.types; let i = index">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span i18n>Type {{i + 1 | number:'2.0'}}</span>
              <mat-error *ngIf="typeForm.controls[i].invalid">
                <mat-icon>error</mat-icon>
              </mat-error>
            </mat-panel-title>
            <mat-panel-description>
              <span i18n *ngIf="type.configuration.network_type === 'balanced'">Balanced</span>
              <span i18n *ngIf="type.configuration.network_type === 'unbalanced'">Unbalanced</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div>
            <app-balanced-unbalanced-toggle [value]="type.configuration.network_type"
              (valueChange)="updateBalancedUnbalancedToggle(i, $event)">
            </app-balanced-unbalanced-toggle>
          </div>
          <ng-container *ngIf="type.configuration.network_type === 'balanced'">
            <app-vertical-balanced-form [type]="type" [form]="typeForm.controls[i]"
              [accessPerPon]="form.value.horizontal_collective_access_per_pon"></app-vertical-balanced-form>
          </ng-container>
          <ng-container *ngIf="type.configuration.network_type === 'unbalanced'">
            <app-vertical-unbalanced-form [type]="type" [form]="typeForm.controls[i]"
              [accessPerPon]="form.value.horizontal_collective_access_per_pon"></app-vertical-unbalanced-form>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </section>

    <section>
      <div fxFlex="25">
        <mat-form-field class="app-block" appearance="outline">
          <mat-label i18n>Max attendance length cable</mat-label>
          <input #maxAttendanceLengthCable type="number" formControlName="max_attendance_length_cable" matInput>
          <mat-hint i18n>Meters</mat-hint>
        </mat-form-field>
        <app-suggestion [input]="maxAttendanceLengthCable" [options]="[80, 100, 120, 150]"
          (changeSelection)="form.patchValue({max_attendance_length_cable: $event})">
        </app-suggestion>
      </div>
    </section>

    <section>
      <h3 i18n>Box-Drop</h3>
      <mat-button-toggle-group formControlName="connector_box_drop" class="options">
        <mat-button-toggle value="factory_connector" i18n>FACTORY</mat-button-toggle>
        <mat-button-toggle value="field_connector" i18n>FIELD</mat-button-toggle>
        <mat-button-toggle value="fusion" i18n>FUSION</mat-button-toggle>
      </mat-button-toggle-group>
    </section>

    <section>
      <app-fiber-connection [form]="form" [settings]="parameters.horizontal_collective_settings"></app-fiber-connection>
    </section>

  </ng-container>

</form>
